import React from 'react';
import cn from 'classnames';
import getName from '../../../helpers/getName';
import styles from './PersonWithPosition.module.scss';

const getPersonName = (person) => {
  if (!person) {
    return 'Не указан';
  }

  if (person.firstName && person.surName) {
    return `${person.surName} ${person.firstName}`;
  }

  return getName(person);
};

const PersonWithPosition = ({ className, person }) => {
  return (
    <div className={cn(styles.root, className)}>
      {person?.specialityName && (
        <span className={styles.speciality}>{person.specialityName}</span>
      )}
      <span>{getPersonName(person)}</span>
    </div>
  );
};

export default PersonWithPosition;
